import React from "react";

import './styles.css'

import CloseIcon from '@mui/icons-material/Close';
import {
  IconButton,
  Box,
  Typography,
  Button,
} from '@mui/material';


function DeleteExerc(props){
  //const [choose, setChoose] = useState('Disponível');

  //const handleChoose = () => {
  //  setChoose('Escolhido');
  //}

  return (props.trigger) ? (
    <Box className="popup">
        <Box className="popup-inner">
            {/*props.ex.membros {props.ex.name} */ }
            
            <Typography align="center" sx={{paddingTop:2}} variant="subtitle1">Deseja apagar o exercício "{props.content.name}"?</Typography>
            <Box textAlign='center' m={2}>
                <Button variant='contained' color='error' size="small" >Apagar</Button>
                <Button variant='contained' color='inherit' size = "small" onClick={() => props.setTrigger(false)}>Cancelar</Button>
            </Box>
                    
                
            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
    </Box>
     
  ) : "";
}
export default DeleteExerc
